import React, { Component } from 'react'
import './components/shared/reset.css'
import AppRouter from './routes/index'
import firebase from 'firebase/app'
import 'firebase/auth'
import { register, unregister } from './serviceWorker'
import ClearCache from 'react-clear-cache'
import { AppContextProvider } from './context/appContext'
import axios from 'axios'
import cookie from 'react-cookies'
import ApiURL from './Api/ApiUrl'
import history from './history'
import AXIOS from './http'
// const [language, setLanguage] = useState("en");
import { ThemeProvider } from 'styled-components'
import {
  lightTheme,
  MeetingProvider,
} from 'amazon-chime-sdk-component-library-react'
import moment from 'moment'
import 'moment/locale/pl' // without this line it didn't work

export default class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      appState: {
        theme: 'dark',
      },
    }
  }

  updateName = (name) => {
    this.setState({
      userName: name,
    })
  }

  updateAppState = (state, value) => {
    this.setState({
      ...this.state,
      appState: {
        ...this.state.appState,
        [state]: value,
      },
    })
  }

  componentDidMount = async () => {
    moment.locale('pl')
    register()
    const firebaseConfig = {
      apiKey: 'AIzaSyASgT3c_DTMb-RXuHXpD2JRRNO62r9YpiY',
      authDomain: 'miazga-android.firebaseapp.com',
      databaseURL: 'https://miazga-android.firebaseio.com',
      projectId: 'miazga-android',
      storageBucket: 'miazga-android.appspot.com',
      messagingSenderId: '7011897535',
      appId: '1:7011897535:web:4a8b527e86df21d520b60a',
      measurementId: 'G-LTLESJRJ5W',
    }
    firebase.initializeApp(firebaseConfig)

    firebase
      .auth()
      .signInAnonymously()
      .catch(function (error) {
        // Handle Errors here.
        var errorCode = error.code
        var errorMessage = error.message

        // ...
      })
    this.createAxiosResponseInterceptor()
  }

  resetCache = (emptyCacheStorage) => {
    this.setState({
      isReset: true,
    })
    emptyCacheStorage()
  }

  refreshToken = () => {
    return new Promise((resolve, reject) => {
      return axios({
        method: 'post',
        url: `${ApiURL}/api/auth/token/refresh/`,
        headers: {},
        data: {
          refresh: cookie.load('refreshToken'), // This is the body part
        },
      })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  createAxiosResponseInterceptor = () => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        // Reject promise if usual error
        if (error.response.status !== 401) {
          return Promise.reject(error)
        }

        /*
         * When response code is 401, try to refresh the token.
         * Eject the interceptor so it doesn't loop in case
         * token refresh causes the 401 response
         */
        axios.interceptors.response.eject(interceptor)

        return axios
          .post(`${ApiURL}/api/auth/token/refresh/`, {
            refresh: cookie.load('refreshToken'),
          })
          .then((response) => {
            cookie.save('accessToken', response.data.access)
            error.response.config.headers['Authorization'] =
              'Bearer ' + response.data.access
            return axios(error.response.config)
          })
          .catch((error) => {
            cookie.remove('accessToken', { path: '/' })

            if (
              (error.response.config.url ==
                'https://srln-fmw.herokuapp.com/api/auth/token/refresh/' ||
                error.response.config.url ==
                  'https://fmw-backend.herokuapp.com/api/auth/token/refresh/') &&
              error.response.status == 401
            ) {
              history.push('/zaloguj')
              window.location.reload()
            }
            if (error.response.status !== 404) {
              history.push('/zaloguj')
            } else {
            }
            return Promise.reject(error)
          })
          .finally(this.createAxiosResponseInterceptor)
      }
    )
  }

  render() {
    const appContextValue = {
      appState: this.state.appState,
      name: this.state.userName,
      update: this.updateName,
      updateAppState: this.updateAppState,
    }

    return (
      <div className="FMWApp">
        <AppContextProvider value={appContextValue}>
          <AppRouter />
        </AppContextProvider>
      </div>
    )
  }
}
